




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { DepositPayableType } from '@/modules/deposit/models/deposit-resource.model'

@Component
export default class DepositPayableTypeView extends Vue {
  @Prop({ required: true }) type!: DepositPayableType
  @Prop({ required: true }) types!: { [key in DepositPayableType]: string }
  @Prop({ default: false }) dark: boolean

  get typeColor() {
    switch (this.type) {
      case DepositPayableType.USER:
        return 'text-orange'
      default:
        return ''
    }
  }
}
